import { Organizer } from '../interfaces/organizer';
import _ from 'lodash';
import { onlyNumber } from 'shared/utils/regx/only-number';

export function filteringByPhone(organizers: Organizer[] | undefined, filter: string | undefined) {
  if (!filter) return organizers;

  return _.reduce(
    organizers,
    (acc, organizer) => {
      const organizerPhone = onlyNumber(organizer?.phone);
      const filterPhone = onlyNumber(filter);

      if (organizerPhone.includes(filterPhone)) {
        acc.push(organizer);
        return acc;
      }

      return acc;
    },
    [] as Organizer[],
  );
}
